<script>
  import { getContext } from "svelte";
  import Surprise from "./Surprise.svelte";
  const { open } = getContext("simple-modal");
  const showSurprise = () => {
    open(Surprise);
  };
</script>

  <small on:click={showSurprise} class="dv" style='font-size:14px;font-family: "mvtyper", "Cairo", "Amiri", sans-serif;'>މައުލޫމާތު</small>
